import React, { useState } from "react";
import { DatePicker, Space, notification } from "antd";

import { EXPORT_LABELS } from "../../constants/exports";

const MAX_EXPORT_RANGE_MONTHS = 3;

const exceedsMaxRange = (dates) => {
  if (!dates || !dates[0] || !dates[1]) return false;
  const monthsSpanned =
    dates[1].clone().startOf("month").diff(dates[0].clone().startOf("month"), "months") + 1;
  if (monthsSpanned > MAX_EXPORT_RANGE_MONTHS) {
    notification.error({
      message: "Date Range cannot be more than 3 months.",
      placement: "bottomRight",
    });
    return true;
  }
  return false;
};

const ExportFilters = ({
  filters,
  onFiltersChange,
  type,
  label = EXPORT_LABELS.ORDER_AT,
}) => {
  return (
    <Space size="large" wrap>
      {type === "topup" ? (
        <React.Fragment>
          <div>
            {EXPORT_LABELS.TOPUP_BEFORE} :{" "}
            <DatePicker.RangePicker
              value={[filters.startBeforeDate, filters.endBeforeDate]}
              onChange={(dates) => {
                if (exceedsMaxRange(dates)) return;
                onFiltersChange({
                  ...filters,
                  startBeforeDate: dates ? dates[0] : undefined,
                  endBeforeDate: dates ? dates[1] : undefined,
                });
              }}
            />
          </div>
          <div>
            {EXPORT_LABELS.TOPUP_AFTER} :{" "}
            <DatePicker.RangePicker
              value={[filters.startAfterDate, filters.endAfterDate]}
              onChange={(dates) => {
                if (exceedsMaxRange(dates)) return;
                onFiltersChange({
                  ...filters,
                  startAfterDate: dates ? dates[0] : undefined,
                  endAfterDate: dates ? dates[1] : undefined,
                });
              }}
            />
          </div>
        </React.Fragment>
      ) : (
        <div>
          {label} :{` `}
          <DatePicker.RangePicker
            value={[filters.startDate, filters.endDate]}
            onChange={(dates) => {
              if (exceedsMaxRange(dates)) return;
              dates
                ? onFiltersChange({
                    ...filters,
                    startDate: dates[0],
                    endDate: dates[1],
                  })
                : onFiltersChange({
                    ...filters,
                    startDate: undefined,
                    endDate: undefined,
                  });
            }}
          />
        </div>
      )}
    </Space>
  );
};

export default ExportFilters;
